import type { StoreResponse } from 'api/Stores/types'
import { Loader, Modal, StoreDetails, Table } from 'components'
import moment from 'locale/momentLocale'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { CompanyDelayed, Date, Hour } from './CellComponents'

interface Props {
  details: {
    countryId: string
    storeId: number
  }
  fetchStoreDetails: () => void
  hideDetails: () => void
  isFetching: boolean
  openDetails: (countryId: string, storeId: number) => void
  store: StoreResponse
  stores: StoreResponse[]
  todayDateChosen: boolean
}

function ClosedReporting({
  details,
  fetchStoreDetails,
  hideDetails,
  isFetching,
  openDetails,
  store: modalStore,
  stores: delayedStores,
  todayDateChosen,
}: Props) {
  const { t: translate } = useTranslation()
  const stores = delayedStores
    .map(store => ({
      timestamp: store.timestamp,
      countryId: store.countryId,
      countryName: `${store.storeChannel} ${store.storeName}`,
      storeId: store.storeId,
    }))
    .sort((a, b) => moment(b.timestamp).diff(a.timestamp, 'seconds') || a.countryName.localeCompare(b.countryName))
  const todayColumns = [
    {
      key: 'date',
      title: translate('common.date'),
      CellRender: Date,
    },
    {
      key: 'hour',
      title: translate('revenue.stats.completeness.hour'),
      CellRender: Hour,
    },
  ]
  const columns = [
    {
      key: 'store',
      title: translate('revenue.stats.completeness.store'),
      CellRender: CompanyDelayed,
    },
    ...(todayDateChosen ? todayColumns : []),
  ]
  const showDetails = modalStore?.storeId // || details.countryId

  return isFetching ? (
    <Loader />
  ) : (
    <>
      <Table
        columns={columns}
        data={stores}
        onRowClick={({ countryId, storeId }: any) => openDetails(countryId, storeId)}
        tableClassName="completeness-details-table"
      />
      {showDetails && (
        <Modal hideModal={hideDetails}>
          <StoreDetails
            countryId={details.countryId}
            fetchStoreDetails={fetchStoreDetails}
            hideModal={hideDetails}
            storeId={modalStore?.storeId}
          />
        </Modal>
      )}
    </>
  )
}

export default ClosedReporting
